<template>
  <div class="inmain">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Inmain"
};
</script>

<style lang="stylus" scoped></style>
